export default {
  get name(): string {
    return 'ExpoIntentLauncher';
  },
};
